import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { CommentTemplateType } from '@/shared/types'
import { UploadRawFile } from 'element-plus'

class CommentApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public addComment(reportId: number, text: string, files: UploadRawFile[]) {
    const formData = new FormData()

    files.forEach((file) => {
      formData.append('files[]', file)
    })
    formData.append('text', text)

    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/reports/add-comment/${reportId}`,
      data: formData,
    })
  }

  public removeComment(commentId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/reports/delete-comment/${commentId}`,
    })
  }

  public getCommentTemplate() {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/get-templates',
    })
  }

  public addCommentTemplate(template: string) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/add-template',
      data: {
        template,
      },
    })
  }

  public editCommentTemplate(commentTemplate: CommentTemplateType) {
    const { template_id, template } = commentTemplate

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/edit-template',
      data: {
        template_id,
        template,
      },
    })
  }

  public editCuraproxTemplate(userId: number, commentTemplate: string) {
    return this.axiosCall({
      method: 'patch',
      url: `/api/web/admin/users/${userId}/template`,
      data: {
        template: commentTemplate,
      },
    })
  }
}

export const commentApi = new CommentApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
